const DAY_MS = 24 * 60 * 60 * 1000;

/** Milliseconds for a date-ish value, or null when missing/invalid. */
export const toTime = (value: string | Date | null | undefined): number | null => {
  if (!value) return null;
  const t = value instanceof Date ? value.getTime() : new Date(value).getTime();
  return Number.isNaN(t) ? null : t;
};

/** Whole days since `value` (negative for future dates), or null. */
export const daysSince = (value: string | Date | null | undefined): number | null => {
  const t = toTime(value);
  return t === null ? null : Math.floor((Date.now() - t) / DAY_MS);
};

/** True when `value` falls within the last `days` days (inclusive of now). */
export const withinLastDays = (value: string | Date | null | undefined, days: number): boolean => {
  const t = toTime(value);
  return t !== null && t <= Date.now() && Date.now() - t <= days * DAY_MS;
};

/** True when `value` is a valid time strictly after now. */
export const isFuture = (value: string | Date | null | undefined): boolean => {
  const t = toTime(value);
  return t !== null && t > Date.now();
};

/** Latest of several date-ish values, as an ISO string (null when none are valid). */
export const latestOf = (values: Array<string | Date | null | undefined>): string | null => {
  const times = values.map(toTime).filter((t): t is number => t !== null);
  return times.length ? new Date(Math.max(...times)).toISOString() : null;
};

export const plural = (n: number, word: string, pluralWord = `${word}s`): string =>
  n === 1 ? word : pluralWord;
